import { render } from "./AdminNewFAQQuestion.vue?vue&type=template&id=e8701958"
import script from "./AdminNewFAQQuestion.vue?vue&type=script&lang=js"
export * from "./AdminNewFAQQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__